// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Overview_wrapper__Y9Osz"};